import { graphql } from 'react-relay';

export default graphql`
  mutation confirmDeliveryWithoutAuthMutation(
    $input: PackageTrackerDeliveryConfirmationByRecipientWithoutAuthMutationInput!
  ) {
    packageTrackerDeliveryConfirmationByRecipientWithoutAuth(input: $input) {
      success
    }
  }
`;
